module.exports = __webpack_public_path__ + "media/dogs/labrador-4b6c7300.svg";